import React from 'react'
import { TypographyV2 as Typography } from '@which/seatbelt'

export const ConversationArticles: React.FC = () => {
  // @TODO: Previous integration was using FE fetch to decomissioned wordpress conversation site
  // Needs hooking up to Glide articles

  return <Typography textStyle="sb-text-body-default-regular">Articles not available.</Typography>
}
